import { combineReducers } from 'redux';
import giftCardList from './giftCardReducer';
import addGiftCard from './addGiftCardReducer';
import checkBalance from './checkBalance';
import buyGiftCard from './buyGiftCard';
import denomination from './denomination';
import updateGiftList from './updateGiftList';
import sendNotification from './notificationReducer';
import getStateList from './getStateListReducer';
import mailer from './mailerReducer';

export default combineReducers({
	giftCardList,
	addGiftCard,
	checkBalance,
	buyGiftCard,
	denomination,
	updateGiftList,
	sendNotification,
	getStateList,
	mailer
});
